import React from 'react';
import { ICustomSpinner } from './CustomSpinnerTypes';
import { customSpinnerStyles } from './CustomSpinner.styles';

const CustomSpinner: React.FC<ICustomSpinner> = ({
	fullScreen = true,
	input = false,
	top = false
}) => {
	const classes = customSpinnerStyles();

	return (
		<div
			className={
				input ? '' : fullScreen ? classes.containerLoader : classes.divLoader
			}
		>
			<div
				className={`${classes.loader} ${input
					? classes.loaderInput
					: fullScreen
						? classes.loaderFull
						: classes.loaderMini
					} ${top ? classes.loaderTop : ''}`}
			/>
		</div>
	);
};

export default CustomSpinner;
